import styles from "../../styles/proposal/Necessity.module.css";
import classNames from "classnames/bind";
import necessityData from "../../data/necessity.json";

const cx = classNames.bind(styles);

export default function Necessity() {
  const entrust = necessityData?.entrust?.[0];
  const effect = necessityData?.entrust?.[1];

  return (
    <div className={cx("necessityWrap")}>
      {/* TITLE */}
      <div className={cx("title")}>
        <h4>위임의 필요성 및 효과</h4>
        <p className={cx("subtitle")}>
          손해사정 전문가 선임을 통한 합리적 보험금 산정
        </p>
      </div>

      <div className={cx("sectionWrap", "reveal")}>
        <div className={cx("section", "card")}>
          <h4 className={cx("sectionTitle")}>{entrust?.title}</h4>

          {/* DESC */}
          <div className={cx("descBox")}>
            {entrust?.desc?.map((text, idx) => (
              <p key={idx}>{text}</p>
            ))}
          </div>

          <div className={cx("coreWrap")}>
            <div className={cx("coreItem")}>
              <img
                src={entrust?.core?.[0]?.icon}
                className={cx("icon")}
                alt="core-icon"
              />
              <p>{entrust?.core?.[0]?.label}</p>
            </div>

            <div className={cx("arrow")}>=</div>

            <div className={cx("effectWrap")}>
              {entrust?.effect?.map((item, idx) => (
                <div key={idx} className={cx("effectItem")}>
                  <img
                    src={item.icon}
                    className={cx("icon")}
                    alt="effect-icon"
                  />
                  <p>{item.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className={cx("sectionWrap", "reveal")}>
        <div className={cx("section", "card")}>
          <h4 className={cx("sectionTitle")}>{effect?.title}</h4>

          <div className={cx("descBox")}>
            {effect?.desc?.map((text, idx) => (
              <p key={idx}>{text}</p>
            ))}
          </div>

          <div className={cx("stepWrap")}>
            {effect?.effect?.map(
              (step, idx) =>
                step.step && (
                  <div key={idx} className={cx("stepItem")}>
                    <div className={cx("stepNumber")}>{step.step}</div>

                    <p>{step.label}</p>
                  </div>
                )
            )}
          </div>

          <div className={cx("resultBox")}>
            {effect?.effect?.find((item) => item.result)?.result}
          </div>
        </div>
      </div>
    </div>
  );
}
